import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Address from "../Address";
import Contact from "../Contact";

const BillingAddress = ({ onChangeUseShippingAddress, useShippingAddress }) => {
	return (
		<div className="w-full flex flex-col">
			<div className="flex flex-col mb-10">
				<Typography className="text-16 font-medium">Billing Address</Typography>
				<FormControlLabel
					control={
						<Checkbox
							checked={useShippingAddress}
							onChange={onChangeUseShippingAddress}
						/>
					}
					label="Use shipping address"
				/>
			</div>
			{!useShippingAddress && (
				<>
					<Contact />
					<Address />
				</>
			)}
		</div>
	);
};

export default BillingAddress;
